/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswebguests2Inputs */

const en_statswebguests2 = /** @type {(inputs: Statswebguests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web guests`)
};

const de_statswebguests2 = /** @type {(inputs: Statswebguests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web-Gäste`)
};

/**
* | output |
* | --- |
* | "Web guests" |
*
* @param {Statswebguests2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswebguests2 = /** @type {((inputs?: Statswebguests2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswebguests2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswebguests2(inputs)
	return de_statswebguests2(inputs)
});
export { statswebguests2 as "statsWebGuests" }